<template>
 <div id="expense-container" class="container p-0">
   <div class="d-flex justify-content-between py-7 border-bottom p-5">
     <h1 class="fs-2hx"> {{ expense['type_'+locale] }} </h1>
     <span class="fs-5 fw-semibold"> {{ $t('expense.createdAt') }} {{ new Date(expense?.created_at).toLocaleDateString() }} </span>
   </div>
   <div class="border-top border-bottom py-5 ps-7 pe-5">
     <div class="d-flex justify-content-between">
       <span> {{ $t('expense.createdBy') }} </span>
       <span> {{ expense?.user?.fullname }} </span>
     </div>
     <div class="d-flex justify-content-between">
       <span> {{ $t('expense.offices') }} </span>
       <span> {{ expense?.office?.name }} </span>
     </div>
     <div class="d-flex justify-content-between">
       <span> {{ $t('expense.feesNumber') }}</span>
       <span> {{ Number(expense?.fees?.length).toString().padStart(2, '0') }} </span>
     </div>
     <div class="d-flex justify-content-between">
       <span> {{ $t('expense.filesNumber') }} </span>
       <span>
        {{ Number(expense.fees?.reduce((acc, cur) => acc + (cur?.fee_with_invoice_url?.length || 0), 0)).toString().padStart(2, '0') }}
      </span>
     </div>
   </div>
   <div>
     <h1 class="text-center my-10 fs-2hx"> {{ expense.title }} </h1>
     <div style="min-height: 400px;">
       <div class="table-responsive px-5">
         <table class="table text-center table-rounded rounded-xl mb-5">
           <thead class="bg-light-primary">
           <tr class="py-3 rounded-5">
             <th>{{$t('expense.label.reason')}}</th>
             <th>{{$t('expense.label.invoiceNumber')}}</th>
             <th>{{$t('expense.label.amount')}}</th>
             <th>{{$t('expense.label.currency')}}</th>
             <th>{{$t('expense.label.expenseDate')}}</th>
             <th>{{$t('expense.label.justif')}}</th>
           </tr>
           </thead>
           <tbody>
           <Item v-for="(fee, index) in expense?.fees" :key="index" :fee="fee" :index="index" :currency="expense?.currency?.symbol"/>
           </tbody>
           <tfoot class="bg-light-primary">
           <tr class="py-3 rounded-5">
             <td colspan="5" class="rounded-bottom rounded-bottom-5 text-start">
               <span class="fs-2x fw-bolder ms-10"> {{ $t('expense.totalExpenseAmount') }} </span>
             </td>
             <td colspan="5">
               <span class="fs-2x fw-bolder text-primary"> {{ $formatLocalAmount(expense?.fees_sum_amount) }} {{ expense?.currency?.symbol }} </span>
             </td>
           </tr>
           </tfoot>
         </table>
       </div>
     </div>
   </div>
  </div>
</template>

<script setup>
import {computed, defineProps} from 'vue'
import {useStore} from "vuex";
import {useLocales} from "@/composables/locales";
import Item from "./Item";
import {$formatLocalAmount} from "@/mixins/Helpers";

const { locale } = useLocales()
const store = useStore()

const props = defineProps({
    expense: { type: Object, required: true }
})

const company = computed(() => store.getters['company/getCompanyInfos'])

</script>

<style scoped>
  .container {
    width: 100%;
    max-width: 800px;
    margin: 20px auto;
    border: 1px solid #e0e0e0;
    border-radius: 5px;
  }

  thead tr {
    font-weight: 600;
  }
</style>
